import messages from "messages";
// utils
import getClasses from "utils/getClasses";
// styles
import styles from "./styles.module.scss";

/**
 * map status with string and style class
 * TODO: should restrict the children type to the data transfer status type
 * use "processing" and "imported" for now
 */
const STATES = {
  processing: { subclass: "processing", stringId: "processing" },
  imported: { subclass: "imported", stringId: "imported" },
};

type Props = {
  value: string;
};

/**
 * renders a tag UI for data transfer complete task
 */
const DataTransferTag = ({ value }: Props) => {
  return (
    <div
      className={getClasses(
        styles["data-transfer-tag"],
        styles[`data-transfer-tag--${STATES[value].subclass}`],
      )}
    >
      {messages[STATES[value].stringId]}
    </div>
  );
};

export default DataTransferTag;
